module.exports = __webpack_public_path__ + "static/media/ic_kuljetus_huolinta_yritykset.a00f66b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_kuljetus_huolinta_yritykset.svg
// module id = 1171
// module chunks = 0